import { store } from 'react-notifications-component';

// react-notifications-component renders `message` as a React child, so a
// non-string (e.g. a raw Facebook Graph error object
// {message,type,code,fbtrace_id} forwarded by an OAuth failure) throws
// React #31 and crashes the WHOLE page the toast mounts into. Every
// message is reduced to a readable string here so no call site can crash
// the app with an object again.
export const toMessageString = (x) => {
  if (x == null || x === '') return '';
  if (typeof x === 'string') return x;
  if (x instanceof Error) return x.message || String(x);
  if (typeof x === 'object') {
    const m = x.message || x.error_description || x.error || x.err;
    if (typeof m === 'string' && m) return m;
    // .error may itself be an object (Graph nests {error:{message,...}}).
    if (m && typeof m === 'object' && typeof m.message === 'string') return m.message;
    try { return JSON.stringify(x); } catch (_) { return String(x); }
  }
  return String(x);
};

const addNotification = (message, type) => {
  store.addNotification({
    title: 'prigmar notification',
    message: toMessageString(message) || 'Error',
    type: type,
    insert: 'bottom',
    container: 'bottom-right',
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: {
      duration: 5000,
      onScreen: true,
    },
  });
};

export default addNotification;
